import { applyTheme } from "./slide-themes";

// Raw slide data - just content, no styling
const nxplanSlidesData = [
  {
    id: "nxplan-overview",
    image: "/sliders/nxplan/1_nxplan.png",
    imageAlt: "NXPlan overview",
    imagePosition: "left",
    kicker: "Decarbonisation Planning",
    title: "NXPlan",
    sections: [
      {
        description: [
          "Model science-based reduction pathways and instantly see the operational impact.",
          "Compare scenarios, timelines, and budgets to build a pragmatic, cost-effective roadmap.",
          "Confidently communicate targets to leadership, investors, and regulators.",
        ],
      },
    ],
  },
  {
    id: "2_ghg_emission_activities",
    image: "/sliders/nxplan/2_ghg_emission_activities.png",
    imageAlt: "GHG Emission Activites",
    imagePosition: "right",
    title: "Structured GHG emission inventories",
    sections: [
      {
        description: [
          "Centralise Scope 1, 2, and 3 sources with clear ownership and evidence attachments.",
          "Automated calculations and emission factors reduce manual spreadsheet effort.",
          "Build an auditable baseline that underpins every sustainability disclosure.",
        ],
      },
    ],
  },
  {
    id: "3_emission_hotspots",
    image: "/sliders/nxplan/3_emission_hotspots.png",
    imageAlt: "Emission Hotspots",
    imagePosition: "left",
    title: "Identify emission hotspots instantly",
    sections: [
      {
        description: [
          "Visual analytics exposes high-impact sites, assets, and processes.",
          "Prioritise decarbonisation initiatives based on abatement potential and payback.",
          "Create focused action plans for subsidiaries or business units with a few clicks.",
        ],
      },
    ],
  },
  {
    id: "4_carbon_neutral_planning",
    image: "/sliders/nxplan/4_carbon_neutral_planning.png",
    imageAlt: "Carbon Neutral Planning",
    imagePosition: "left",
    title: "Carbon neutral planning made actionable",
    sections: [
      {
        description: [
          "Simulate technology mixes, CAPEX/OPEX trade-offs, and emission outcomes.",
          "Phase investments across short-, mid-, and long-term horizons with scenario planning.",
          "Tie every initiative back to SBTi-aligned targets with live variance tracking.",
        ],
      },
    ],
  },
  {
    id: "5_external_support",
    image: "/sliders/nxplan/5_external_support.png",
    imageAlt: "External Supports",
    imagePosition: "left",
    title: "Unlock funding and incentives",
    sections: [
      {
        description: [
          "Surface grants, subsidies, and technical assistance relevant to each project.",
          "Track application deadlines and documentation requirements in one workspace.",
          "Reduce the cost of implementation by aligning with partner ecosystems early.",
        ],
      },
    ],
  },
  {
    id: "6_report_declaration",
    image: "/sliders/nxplan/6_report_declaration.png",
    imageAlt: "Report Declaration",
    imagePosition: "left",
    title: "Compliant reporting on demand",
    sections: [
      {
        description: [
          "Produce branded PDF packs or data extracts aligned to CSRD, ISSB, and TCFD.",
          "Publish progress dashboards for executives, sustainability teams, and investors.",
          "Maintain stakeholder confidence with transparent assumptions and traceability.",
        ],
      },
    ],
  },
];

// Apply themes to slides
export const nxplanSlides = nxplanSlidesData.map((slide, index) => {
  const theme =
    index % 3 === 0 ? "default" : index % 3 === 1 ? "emerald" : "sky";
  return applyTheme(slide, theme, "green");
});
